export const NAVY       = '#1B2A4A';
export const NAVY_LIGHT = '#243352';
export const GOLD       = '#B59A6A';
export const GOLD_LIGHT = '#D4BC8E';
export const BG         = '#F7F5F0';
export const WHITE      = '#FFFFFF';

export const PRIORITIES    = ['Critical', 'High', 'Medium', 'Low'];
export const PRIORITY_COLORS = { Critical:'#C0392B', High:'#E67E22', Medium:'#B59A6A', Low:'#5D8A5E' };

export const STATUSES = [
  'Not Started','In Progress','Waiting for Client','Waiting for Counterparty',
  'Waiting for Regulator','Under Review','Completed','Closed'
];
export const STATUS_COLORS = {
  'Not Started':'#95A5A6','In Progress':'#2980B9','Waiting for Client':'#8E44AD',
  'Waiting for Counterparty':'#E67E22','Waiting for Regulator':'#D35400',
  'Under Review':'#F39C12','Completed':'#27AE60','Closed':'#7F8C8D'
};

export const ROLES      = ['Managing Partner','Partner','Senior Lawyer','Lawyer','Administrative','Accounting','Client Relationship Manager','Admin'];
export const NOTE_TYPES = ['General','Legal','Commercial','Client Communication','Risk'];
export const MATTER_TYPES = ['Banking','Regulatory','Corporate','Litigation','Arbitration','Real Estate','Employment','Other'];

export const fmt     = d => d ? new Date(d).toLocaleDateString('en-GB',{day:'2-digit',month:'short',year:'numeric'}) : '—';
export const today   = () => new Date().toISOString().slice(0,10);
export const isOver  = d => d && new Date(d) < new Date();
export const initials = name => name.split(' ').map(p=>p[0]).join('').toUpperCase().slice(0,2);

export function Pill({ label, color, size=12 }) {
  return (
    <span style={{
      background: color+'22', color, border:`1px solid ${color}44`,
      borderRadius:20, padding:'2px 10px', fontSize:size, fontWeight:600, whiteSpace:'nowrap'
    }}>{label}</span>
  );
}

export function Avatar({ name, size=32 }) {
  return (
    <div style={{
      width:size, height:size, borderRadius:'50%', background:NAVY, color:GOLD,
      display:'flex', alignItems:'center', justifyContent:'center',
      fontSize:size*0.35, fontWeight:700, flexShrink:0, fontFamily:'Georgia,serif'
    }}>{initials(name)}</div>
  );
}

export function Btn({ children, variant='primary', style:s={}, ...props }) {
  const styles = {
    primary : { background:NAVY,  color:WHITE,       border:'none' },
    gold    : { background:GOLD,  color:NAVY,        border:'none' },
    danger  : { background:'#C0392B', color:WHITE,   border:'none' },
    outline : { background:'transparent', color:NAVY, border:`1px solid ${NAVY}` },
    ghost   : { background:'transparent', color:'#888', border:`1px solid #D0CBBF` },
  };
  return (
    <button {...props} style={{
      ...styles[variant], borderRadius:7, padding:'9px 18px',
      fontSize:13, fontWeight:600, cursor:'pointer', fontFamily:'inherit', ...s
    }}>{children}</button>
  );
}

export function Input(props) {
  return <input {...props} style={{
    border:'1px solid #D0CBBF', borderRadius:6, padding:'8px 10px',
    fontSize:14, background:'#FAFAF8', width:'100%', boxSizing:'border-box',
    fontFamily:'inherit', ...(props.style||{})
  }} />;
}

export function Select({ children, ...props }) {
  return (
    <select {...props} style={{
      border:'1px solid #D0CBBF', borderRadius:6, padding:'8px 10px',
      fontSize:14, background:'#FAFAF8', width:'100%', fontFamily:'inherit',
      ...(props.style||{})
    }}>{children}</select>
  );
}

export function Textarea(props) {
  return <textarea {...props} rows={props.rows||3} style={{
    border:'1px solid #D0CBBF', borderRadius:6, padding:'8px 10px',
    fontSize:14, background:'#FAFAF8', width:'100%', resize:'vertical',
    boxSizing:'border-box', fontFamily:'inherit', ...(props.style||{})
  }} />;
}

export function Field({ label, children, col }) {
  return (
    <div style={{ gridColumn:col, display:'flex', flexDirection:'column', gap:4 }}>
      <label style={{ fontSize:11, fontWeight:700, color:NAVY, textTransform:'uppercase', letterSpacing:0.5 }}>{label}</label>
      {children}
    </div>
  );
}

export function Card({ title, children, action }) {
  return (
    <div style={{ background:WHITE, borderRadius:10, border:'1px solid #E5E0D8', padding:'16px 20px' }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:12, paddingBottom:8, borderBottom:'1px solid #F0EDE8' }}>
        <span style={{ fontFamily:'Georgia,serif', fontSize:14, fontWeight:700, color:NAVY }}>{title}</span>
        {action}
      </div>
      {children}
    </div>
  );
}

export function Empty({ text }) {
  return <div style={{ color:'#BBB', fontSize:13, padding:'16px 0', textAlign:'center' }}>{text}</div>;
}

export function NoteText({ text, style = {} }) {
  if (!text) return null;
  const lines = text.split('\n');
  const elements = [];
  lines.forEach((line, i) => {
    const trimmed = line.trim();
    if (!trimmed) { elements.push(<div key={i} style={{ height:8 }} />); return; }
    if (/^\d+[\.\)]/.test(trimmed)) {
      elements.push(
        <div key={i} style={{ display:'flex', gap:8, marginBottom:4, paddingLeft:8 }}>
          <span style={{ color:NAVY, fontWeight:700, minWidth:20, flexShrink:0 }}>{trimmed.match(/^\d+[\.\)]/)[0]}</span>
          <span>{trimmed.replace(/^\d+[\.\)]\s*/, '')}</span>
        </div>
      );
      return;
    }
    if (/^[\*\-•]/.test(trimmed)) {
      const indent = line.search(/\S/);
      elements.push(
        <div key={i} style={{ display:'flex', gap:6, marginBottom:3, paddingLeft:Math.min(indent * 3, 40) }}>
          <span style={{ color:GOLD, fontWeight:700, flexShrink:0, marginTop:1 }}>•</span>
          <span>{trimmed.replace(/^[\*\-•]\s*/, '')}</span>
        </div>
      );
      return;
    }
    if (trimmed.endsWith(':') && trimmed.length < 80) {
      elements.push(
        <div key={i} style={{ fontWeight:700, color:NAVY, marginTop:10, marginBottom:4 }}>{trimmed}</div>
      );
      return;
    }
    elements.push(<div key={i} style={{ marginBottom:4, lineHeight:1.7 }}>{trimmed}</div>);
  });
  return <div style={{ fontSize:13, color:'#333', ...style }}>{elements}</div>;
}

export function Spinner() {
  return (
    <div style={{ display:'flex', justifyContent:'center', alignItems:'center', padding:40 }}>
      <div style={{ width:32, height:32, border:`3px solid ${GOLD}33`, borderTop:`3px solid ${GOLD}`, borderRadius:'50%', animation:'spin 0.8s linear infinite' }} />
      <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
    </div>
  );
}
